var map = {
	"./campaign-logo-alphabet.svg": 555,
	"./campaign-logo-amazon.svg": 556,
	"./campaign-logo-bank-of-america.svg": 557,
	"./campaign-logo-barclays.svg": 558,
	"./campaign-logo-bnp-paribas.svg": 559,
	"./campaign-logo-coca-cola.svg": 560,
	"./campaign-logo-goldman-sachs.svg": 561,
	"./campaign-logo-hsbc.svg": 531,
	"./campaign-logo-ikea.svg": 562,
	"./campaign-logo-jp-morgan.svg": 563,
	"./campaign-logo-meta.svg": 564,
	"./campaign-logo-morgan-stanley.svg": 565,
	"./campaign-logo-oracle.svg": 566,
	"./campaign-logo-pwc.svg": 567,
	"./campaign-logo-walmart.svg": 568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1328;